import { useState } from 'react';
import { Button, Field, Modal } from '../ui';
import { batchApi, apiErrorMessage } from '../../services/api';
import { useOrg } from '../../context/OrgContext';
import { useToast } from '../../context/ToastContext';

export default function BatchDialog({ exams = [], onClose, onCreated }) {
  const org = useOrg();
  const toast = useToast();
  const [saving, setSaving] = useState(false);
  const [name, setName] = useState('');
  const [examId, setExamId] = useState(exams[0]?.examId || '');

  const canCreate = name.trim() && examId && !saving;

  const handleCreate = async () => {
    setSaving(true);
    try {
      await batchApi.create(org.id, { name: name.trim(), examId });
      toast.success(`${name.trim()} created.`);
      onCreated();
    } catch (err) {
      toast.error(apiErrorMessage(err, 'Failed to create batch'));
    } finally {
      setSaving(false);
    }
  };

  return (
    <Modal title="Create batch" onClose={onClose}>
      <div className="form">
        <Field label="Batch name">
          <input placeholder="e.g. CAT 2026 Weekend" value={name} onChange={(e) => setName(e.target.value)} />
        </Field>
        <Field label="Exam">
          <select value={examId} onChange={(e) => setExamId(e.target.value)}>
            <option value="">Select an exam</option>
            {exams.map((x) => <option key={x.examId} value={x.examId}>{x.title}</option>)}
          </select>
        </Field>
        <p className="helper">
          Students in this batch prepare for this exam, and it is the exam their tests must come from.
        </p>
        {!exams.length && (
          <p className="helper">
            Enrol in an exam from the Exam library first, then come back to create a batch.
          </p>
        )}
        <div className="modal-actions">
          <Button variant="secondary" onClick={onClose}>Cancel</Button>
          <Button disabled={!canCreate} onClick={handleCreate}>
            {saving ? 'Creating…' : 'Create batch'}
          </Button>
        </div>
      </div>
    </Modal>
  );
}
